<div class="flex-col">
    <div *ngFor="let tab of app.visibleMenuTabs; index as index" class="sidebar-item" [ngClass]="{'active-item':appComponent.activeTabIndex === index}">
        <a href="#" (click)="appComponent.onTabClick($event, index)">
            <i *ngIf="!tab.iconIsFile" [class]="tab.icon"></i>
            <img *ngIf="tab.iconIsFile" class="icon-from-file" [src]="tab.icon">
        </a>
    </div>
</div>
